module.exports = __webpack_public_path__ + "static/media/shield-alt.584ec5d7.svg";